import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/admin/system-admin/")({
  beforeLoad: () => {
    throw redirect({
      to: "/app/admin/system-admin/roles",
    })
  },
})
